import { Installation } from "../Installation";
import { ScheduleConfiguration } from "./ScheduleConfiguration";

export class InstallationScheduleConfiguration extends Installation {
  schedulesConfigurations: ScheduleConfiguration[] = [];

  constructor() {
    super();
  }

  public parse(obj: any) {
    super.parse(obj);

    if (obj.ScheduleConfigurations && obj.ScheduleConfigurations.length > 0) {
      obj.ScheduleConfigurations.forEach((e) => {
        var ms: ScheduleConfiguration = new ScheduleConfiguration();
        ms.parse(e);
        this.schedulesConfigurations.push(ms);
      });
    }
  }
}
